import React from 'react';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import SolutionExtras, { SolutionSeo } from '../../components/SolutionExtras';
import { SOLUTIONS } from '../../data/solutions';

const S = SOLUTIONS.iot;
import { Cpu, Wifi, Shield, Zap, CheckCircle2, Globe } from 'lucide-react';

const IoT = () => {
  return (
    <div className="min-h-screen pt-24 pb-16">
      <SolutionSeo s={S} name="IoT & M2M" />
      {/* Hero Section */}
      <section className="px-4 sm:px-6 lg:px-8 mb-16">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl font-bold mb-6" style={{ color: '#0a1f2e' }}>
            IoT & M2M Solutions
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Connectivity solutions for IoT devices and machine-to-machine communications.
          </p>
        </div>
      </section>

      {/* Features Section */}
      <section className="px-4 sm:px-6 lg:px-8 mb-16">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-bold mb-8" style={{ color: '#0a1f2e' }}>{S.featuresTitle}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <Cpu className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>Device Connectivity</h3>
              <p className="text-gray-600">Connect millions of IoT devices reliably</p>
            </Card>
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <Wifi className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>SMS & Voice APIs</h3>
              <p className="text-gray-600">Enable device communication via SMS and voice</p>
            </Card>
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <Shield className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>Secure Communication</h3>
              <p className="text-gray-600">End-to-end encryption for device communications</p>
            </Card>
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <Zap className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>Low Latency</h3>
              <p className="text-gray-600">Real-time data transmission with minimal delay</p>
            </Card>
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <CheckCircle2 className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>Scalable Infrastructure</h3>
              <p className="text-gray-600">Scale from thousands to millions of devices</p>
            </Card>
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <Globe className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>Global Coverage</h3>
              <p className="text-gray-600">Connect devices in 90+ countries worldwide</p>
            </Card>
          </div>
        </div>
      </section>

      <SolutionExtras s={S} />

      {/* CTA */}
      <section className="px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <Card className="p-12 text-center bg-gradient-to-br from-[#0a1f2e] to-[#0a2f3e] text-white">
            <h2 className="text-3xl font-bold mb-4">Power your IoT devices with VOIP2</h2>
            <p className="text-xl text-gray-300 mb-8">Explore IoT connectivity solutions</p>
            <Button 
              size="lg"
              style={{ backgroundColor: '#c8ff00', color: '#0a1f2e' }}
              className="hover:opacity-90 font-semibold"
              onClick={() => window.location.href = '/contact'}
            >
              Get Started
            </Button>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default IoT;